import React, { forwardRef } from "react";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";

export interface PasswordFieldProps {
  showPassword: boolean;
  setShowPassword: (value: boolean) => void;
  name?: string;
  label: string;
  fullWidth?: boolean;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  placeholder?: string;
  size?: "small" | "medium";
  variant?: "outlined" | "filled" | "standard";
}

export const PasswordField = forwardRef<HTMLInputElement, PasswordFieldProps>(
  function PasswordField(
    {
      showPassword,
      setShowPassword,
      name,
      label,
      fullWidth = true,
      required = false,
      error = false,
      helperText,
      value,
      onChange,
      onBlur,
      disabled = false,
      placeholder,
      size = "medium",
      variant = "outlined",
      ...props
    },
    ref,
  ) {
    return (
      <TextField
        ref={ref}
        name={name}
        label={label}
        type={showPassword ? "text" : "password"}
        fullWidth={fullWidth}
        variant={variant}
        size={size}
        required={required}
        error={error}
        helperText={helperText}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        placeholder={placeholder}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
                disabled={disabled}
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        {...props}
      />
    );
  },
);
